module.exports = __webpack_public_path__ + "static/media/1.71fa2d86.jpg";